import { LifterListFilter } from './components/lifter-list-filter';
import { LifterListTable } from './components/lifter-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useAuthentication } from '~/hooks/useAuthentication';
import { Button } from '~/components/Button/Button';
import { Fragment } from 'react/jsx-runtime';
import { Link } from 'react-router';

export function Page() {
  const { can } = useAuthentication();

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Katalog av lyftare" />

        {can('create-lifter') && (
          <Button.Group neutral>
            <Link to="create">
              <Button type="button">Skapa ny</Button>
            </Link>
          </Button.Group>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <LifterListFilter />
        <LifterListTable />
      </PageLayout.Section>
    </Fragment>
  );
}
